module.exports = __webpack_public_path__ + "static/media/31.247d5f96.JPG";